var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-breadcrumbs',{staticClass:"px-0 py-1 d-none d-sm-inline-block breads",attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{attrs:{"to":item.to,"exact":"","disabled":item.disabled}},[_vm._v("\n      "+_vm._s(item.text.toUpperCase())+"\n    ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }